import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import { FieldSet, DateStyle } from './dateStyles/dateStyles';

const DateSelection = ({
  date,
  handleChange,
  placeholderText,
  width,
  marginLeft,
}) => {
  const [dateFlag, setDateFlag] = useState(true);
  /** onChangeRaw and onChange are two props provided by <DatePicker /> to handle date change.
   *  onChangeRaw is used when date is typed in and onChange when a date is picked from date picker.
   */
  const handleDateChangeRaw = (e) => {
    // eslint-disable-next-line no-underscore-dangle
    const isDateValid = moment(e.currentTarget.value)._isValid;
    if (isDateValid) {
      setDateFlag(true);
      handleChange(e);
      return;
    }
    setDateFlag(false);
  };
  const handleDateChange = (e) => {
    if (!dateFlag) {
      setDateFlag(true);
    }
    handleChange(e);
  };
  return (
    <FieldSet width={width} marginLeft={marginLeft} fullWidth={width && '110%'}>
      <DateStyle data-tip data-for={date ? null : 'emptyDate'} width={width}>
        <DatePicker
          selected={dateFlag || date === null ? Date.parse(date) : new Date()}
          onChangeRaw={handleDateChangeRaw}
          onChange={handleDateChange}
          className="redBorder"
          placeholderText={placeholderText}
          popperPlacement="bottom-end"
          popperModifiers={{
            offset: {
              enabled: true,
              offset: '32px, 16px',
            },
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
              boundariesElement: 'viewport',
            },
          }}
          onFocus={(e) => {
            e.target.readOnly = true;
          }}
          showMonthDropdown
          useShortMonthInDropdown
          showYearDropdown
          peekNextMonth
        >
          <div data-tip data-for="emptyDate" />
        </DatePicker>
      </DateStyle>
    </FieldSet>
  );
};

DateSelection.propTypes = {
  handleChange: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
};

DateSelection.defaultProps = {
  placeholderText: '',
};

export default DateSelection;
